import AddUsers from "../../team/ModalScreens/AddUsers";
import StepWrapper from "../StepWrapper";

export default function TeamAddUsersStep({
  newUserEmails,
  setNewUserEmails,
  team,
}) {
  return (
    <StepWrapper
      title="Invite Your Team Members"
      description="Add your team members' email addresses. We'll check if they already have Scribenote accounts and send invitations to those who don't."
      withBackground={false}
    >
      <div className="bg-white/10 rounded-xl p-8 border border-white/20 shadow-lg backdrop-blur-xs w-full max-w-[90vw]">
        <AddUsers
          newUserEmails={newUserEmails}
          setNewUserEmails={setNewUserEmails}
          team={team}
        />
      </div>
    </StepWrapper>
  );
}
